var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.753 12.1182C16.8322 11.7003 16.8737 11.2691 16.8737 10.8283C16.8737 9.09926 16.2359 7.51926 15.1827 6.31066M3.45703 8.67835C4.10981 6.6923 5.64245 5.10545 7.59383 4.37891M11.2839 17.5871C10.8662 17.6664 10.4349 17.7078 9.99408 17.7078C8.36575 17.7078 6.86952 17.1422 5.69126 16.1965",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66732C11.2657 6.66732 12.2917 5.6413 12.2917 4.37565C12.2917 3.11 11.2657 2.08398 10 2.08398C8.73436 2.08398 7.70834 3.11 7.70834 4.37565C7.70834 5.6413 8.73436 6.66732 10 6.66732Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07961 12.3913C4.17552 11.7587 5.57685 12.1341 6.20956 13.23C6.84229 14.3259 6.46681 15.7272 5.3709 16.36C4.275 16.9927 2.87367 16.6172 2.24095 15.5213C1.60823 14.4254 1.98371 13.0241 3.07961 12.3913Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6226 16.36C13.5267 15.7272 13.1512 14.3259 13.7839 13.23C14.4167 12.1341 15.818 11.7587 16.9138 12.3913C18.0097 13.0241 18.3852 14.4254 17.7525 15.5213C17.1198 16.6172 15.7185 16.9927 14.6226 16.36Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTransaction);
export default __webpack_public_path__ + "static/media/order_transaction.5a84233ed0f54e0b9dd76cf81db14232.svg";
export { ForwardRef as ReactComponent };